import { render } from "./QuestionsList.vue?vue&type=template&id=2f564fd2"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__